import React, { useState, useEffect, use } from "react";
import { useRouter } from "next/router";
import Link from "@/utils/link";
import moment from "moment";
import { useFormik } from "formik";
import * as yup from "yup";

import { PlusIcon, CreditCardIcon } from "@heroicons/react/outline";

import { useAuth, updateCookie } from "@/lib/auth";
import Button from "@/ui/Button";
import Table from "@/ui/Table";
import TodoBox from "@/ui/TodoBox";
import Dialog from "@/ui/Dialog";
import TextFieldFormik from "@/ui/TextFieldFormik";

import CpHomeHeader from "../home/CpHomeHeader";
import CpHomeFooter from "../home/CpHomeFooter";
import CpPreReleaseRibbon from "./CpPreReleaseRibbon";

const prettifyCommunityUrl = (url) => {
    const f = url.split("-");
    return f.filter((x, i) => i < f.length - 1 && x !== "").join("-");
};

const CpCommunityConsole = () => {
    const [communities, setCommunities] = useState([]);
    const [openArgentumDialog, setOpenArgentumDialog] = useState(false);
    const router = useRouter();
    const auth = useAuth();
    const uid = auth && auth.user ? auth.user.uid : "";
    const token = auth && auth.user ? auth.user.token : "";

    // update the cookie each time we access this component
    useEffect(() => updateCookie(token), [token]);

    useEffect(() => {
        const fetchData = async (_token) => {
            const res = await fetch("/api/community-portal/community", {
                method: "GET",
                headers: {
                    token: _token,
                },
            });
            const data = await res.json();
            console.log("CpCommunityConsole data", data);
            setCommunities(
                data
                    .map((c) => c.community_link)
                    .map((c) => {
                        let plan = c.plan;
                        if (plan === "Paid") {
                            plan = "Premium";
                        } else if (plan === "Paid Trial") {
                            plan = "Premium Trial";
                        } else if (plan === "Free") {
                            plan = "Basic";
                        }
                        return { ...c, plan };
                    })
            );
        };

        console.log("uid fetch", uid);

        if (token) {
            fetchData(token);
        }
    }, [token]);

    const headers = [
        { name: "name", label: "Community" },
        { name: "plan", label: "Plan" },
        { name: "displayStatus", label: "Status" },
        { name: "publishdedAt", label: "Publish Date" },
        { name: "version", label: "Version" },
    ];

    return (
        <div>
            <CpHomeHeader />
            <div className="w-full">
                <div className="relative w-full sm:h-[266px] bg-primary-500/90 sm:bg-primary-500">
                    <CpPreReleaseRibbon />

                    <div className="relative container mx-auto pt-6 pb-6 sm:pb-0 sm:pt-12 px-4 sm:px-16">
                        <h1 className="text-primary-50 text-2xl font-bold tracking-normal font-headline">
                            My Communities
                        </h1>

                        <div className="mt-8 sm:grid grid-cols-2">
                            <div className="flex space-x-8 mb-4">
                                <div>
                                    <Button
                                        size="lg"
                                        color="white"
                                        className="flex items-center"
                                        onClick={() =>
                                            router.push(
                                                "/community-portal/my-communities/add-community"
                                            )
                                        }
                                    >
                                        <PlusIcon className="w-6 h-6 mr-4" />
                                        Add Community
                                    </Button>
                                </div>

                                {/*<div>
                                    <Button
                                        size="lg"
                                        color="white"
                                        className="flex items-center"
                                        onClick={() => setOpenArgentumDialog(true)}
                                    >
                                        Argentum Information
                                    </Button>
                                </div>*/}

                                {/*<div>
                                    <Button
                                        size="lg"
                                        color="white"
                                        className="flex items-center"
                                        onClick={() =>
                                            router.push(
                                                "/community-portal/my-communities/community-payment"
                                            )
                                        }
                                    >
                                        <CreditCardIcon className="w-6 h-6 mr-4" />
                                        Payment
                                    </Button>
                                </div>

                                <div>
                                    <Button
                                        size="lg"
                                        color="white"
                                        className="flex items-center"
                                        onClick={() =>
                                            router.push(
                                                "/community-portal/my-communities/payment"
                                            )
                                        }
                                    >
                                        <CreditCardIcon className="w-6 h-6 mr-4" />
                                        Test
                                    </Button>
                                </div>*/}
                            </div>

                            <div className="text-white text-base">
                                <p>
                                    Create a new community or select an existing community
                                    below to edit and manage.
                                </p>
                                <p className="mt-4">
                                    If your community is listed on the site but you do not
                                    see it below, please contact{" "}
                                    <a
                                        href="mailto:community@purpledoorfinders.com"
                                        className="text-primary-100 underline hover:font-bold"
                                    >
                                        community@purpledoorfinders.com
                                    </a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                {communities.length < 6 ? (
                    <div className="flex justify-center bg-gray-200">
                        <div className="mt-8 sm:mt-16 sm:mb-8 grid grid-cols-1 sm:grid-cols-3 xl:grid-cols-4 gap-8 content-center">
                            {/*<AddCommunityCard />*/}

                            {communities.map((community) => (
                                <CommunityCard
                                    key={community.nameId + community.cpUrlId}
                                    community={community}
                                />
                            ))}
                        </div>
                    </div>
                ) : (
                    <div className="mt-8 px-4 sm:px-16 pb-8">
                        <Table
                            headers={headers}
                            rows={communities.map((c) => ({
                                ...c,
                                displayStatus: getStatus(c),
                                publishdedAt: c.publishedDateTime
                                    ? moment(c.publishedDateTime).format(
                                          "MMM DD, YYYY - hh:mm A"
                                      )
                                    : "",
                                name: (
                                    <Link
                                        href={
                                            "/community-portal/my-communities/" +
                                            c.cpUrlId +
                                            "/overview"
                                        }
                                    >
                                        <a className="text-primary-500 hover:underline">
                                            {c.name}
                                        </a>
                                    </Link>
                                ),
                            }))}
                        />
                    </div>
                )}

                {/*<div className="bg-gray-100">
                    <div className="container mx-auto py-32 px-4 sm:px-16  h-[800px]">
                        <div className="mb-8 w-full h-full flex items-end">
                            <TodoBox>How to, video, instructions</TodoBox>
                        </div>
                    </div>
                </div>*/}
            </div>

            {/*<ArgentumInformationDialog
                open={openArgentumDialog}
                onClose={() => setOpenArgentumDialog(false)}
            />*/}

            <CpHomeFooter />
        </div>
    );
};

const ArgentumInformationDialog = ({ open, onClose }) => {
    const [initialValues, setInitialValues] = useState({
        name: "",
        email: "",
        personalEmail: "",
        cellPhone: "",
        argentumCertificationNumber: "",
    });

    const validationSchema = yup.object({
        name: yup.string().required("Name is required"),
        email: yup.string().email("Invalid email").required("Email is required"),
        personalEmail: yup
            .string()
            .email("Invalid email")
            .required("Personal Email is required"),
        cellPhone: yup.string().required("Cell Phone is required"),
        argentumCertificationNumber: yup
            .string()
            .required("Argentum Certification Number is required"),
    });

    const formik = useFormik({
        initialValues,
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            console.log("values", values);
            window.localStorage.setItem("argentumInfo", JSON.stringify(values));
            onClose();
        },
    });

    useEffect(() => {
        let _initialValues = window.localStorage.getItem("argentumInfo");
        if (_initialValues) {
            _initialValues = JSON.parse(_initialValues);
            setInitialValues(_initialValues);
            formik.setValues(_initialValues);
        }
    }, []);

    return (
        <Dialog
            open={open}
            onClose={onClose}
            className="fixed z-40 top-32 bottom-6 left-16 right-16 overflow-y-auto"
        >
            <div className="flex items-center justify-center max-w-3xl mx-auto">
                <Dialog.Overlay className="fixed inset-0 bg-black opacity-60" />

                <div className="z-50 px-16 py-8 flex flex-col justify-between bg-white w-full min-h-[400px] border rounded-xl">
                    <div className="mb-8">
                        <h3 className="text-2xl text-primary-500 font-headline font-bold">
                            Argentum Information
                        </h3>

                        {/*<div className="mt-8">
                            <p>Add some text here to explain</p>
                        </div>*/}
                    </div>

                    <form onSubmit={formik.handleSubmit}>
                        <div className="flex flex-col space-y-4">
                            <TextFieldFormik
                                formik={formik}
                                id="name"
                                name="name"
                                label="Name"
                                required
                                fullwidth
                            />

                            <TextFieldFormik
                                formik={formik}
                                type="email"
                                id="email"
                                name="email"
                                label="Email"
                                required
                                fullwidth
                            />

                            <TextFieldFormik
                                formik={formik}
                                type="email"
                                id="personalEmail"
                                name="personalEmail"
                                label="Personal Email"
                                required
                                fullwidth
                            />

                            <TextFieldFormik
                                formik={formik}
                                id="cellPhone"
                                name="cellPhone"
                                label="Cell Phone"
                                required
                                fullwidth
                            />

                            <TextFieldFormik
                                formik={formik}
                                id="argentumCertificationNumber"
                                name="argentumCertificationNumber"
                                label="Argentum Certification Number"
                                required
                                fullwidth
                            />
                        </div>

                        <div className="mt-8 flex justify-between items-center ">
                            <Button
                                variant="outlined"
                                onClick={() => {
                                    formik.resetForm();
                                    window.localStorage.removeItem("argentumInfo");
                                    onClose();
                                }}
                                size="sm"
                            >
                                Clear
                            </Button>

                            <div className="flex justify-end space-x-4">
                                <Button variant="outlined" onClick={onClose} size="sm">
                                    Cancel
                                </Button>
                                <Button type="submit" color="primary" size="md">
                                    Submit
                                </Button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </Dialog>
    );
};

const AddCommunityCard = () => {
    return (
        <button
            className={`w-64 h-48 flex flex-col justify-center items-center bg-primary-50
                    rounded-xl shadow-md border border-gray-300 hover:bg-gray-200`}
        >
            <PlusIcon className="w-8 h-8 text-primary-500" />
            <div className="mt-4 text-primary-500">Add Community</div>
        </button>
    );
};

const getStatus = (community) => {
    switch (community.releaseState) {
        case "EDIT":
            return "Unpublished Changes";

        case "PUBLISHED":
            return "Published";

        case "READY_FOR_REVIEW":
            return "Ready for Approval";

        case "NEW":
            return "New";

        default:
            return community.releaseState;
    }
};

const CommunityCard = ({ community }) => {
    const router = useRouter();

    const handleClick = async () => {
        router.push("/community-portal/my-communities/" + community.cpUrlId + "/overview");
    };

    console.log("version", community.name, community.version);

    return (
        <button
            onClick={handleClick}
            className={`w-64 h-48 p-4 m-0 flex flex-col justify-between text-left bg-primary-50
                    rounded-xl shadow-md border border-gray-300 hover:bg-gray-200`}
        >
            <div className="flex justify-start items-start text-lg font-bold text-black">
                {community.name}
            </div>

            <div className="w-full flex justify-between items-center">
                <div className="font-bold">{community.plan}</div>

                {community.plan !== "Premium" ? (
                    <div className="px-2 py-1 bg-red-500 text-red-100 rounded">
                        Upgrade Now
                    </div>
                ) : null}
            </div>

            <div className="w-full flex justify-between items-center">
                {getStatus(community) ? (
                    <div className="px-2 py-1 bg-primary-500 text-primary-100 rounded">
                        {getStatus(community)}
                    </div>
                ) : null}

                {community.version ? <div>v{community.version}</div> : null}
            </div>
        </button>
    );
};

export default CpCommunityConsole;
